import { render, staticRenderFns } from "./ChangePassword2.vue?vue&type=template&id=1c267326"
import script from "./ChangePassword2.vue?vue&type=script&lang=js"
export * from "./ChangePassword2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports